const { Project } = require("./project.js");

class ProjectPool {
    constructor(simulator, projectData) {
        this.simulator = simulator;
        this.projectData = projectData;
        this.lastSpawnedIndex = -1;
        this.createInitialProjects();
    }

    getData(){
        // return this.projects.filter(project => !project.isFinished()).map(project => project.getData())
        return this.projects.map(project => project.getData())
    }

    createInitialProjects() {
        this.projects = [];

        const startProjectAmount = this.simulator.params.startProjectAmount;

        for (var i = 0; i < startProjectAmount; i++) {
            this.spawnNextProject();
        }
    }

    //Get the next projects
    getNewProject(projectName, startOffset) {
        const projectData = this.getProjectDataFromName(projectName);
        const project = new Project(this.simulator, projectName, projectData, startOffset, this.projects.length);
        return project;
    }

    getProjectDataFromName(currProjectName) {
        var currData = [];

        this.projectData.forEach(currDataPoint => {
            //We're only interested in the datapoints concerning our project
            if (currDataPoint["Project_Name"] != currProjectName) {
                return;
            }
            currData.push(currDataPoint);
        })

        return currData;
    }


    //Check if all the projects are finished
    allProjectsFinished() {
        var allProjectsFinished = true;
        this.projects.forEach(currProject => {
            allProjectsFinished &= currProject.isFinished();
        })

        return allProjectsFinished;
    }

    //Check if its possible to spawn a project, if so do it
    spawnProjectIfReady() {
        if (this.simulator.hoursPassed == 0) {
            return;
        }
        if (this.simulator.params.spawnProjectRate == null) {
            return;
        }
        if (this.simulator.hoursPassed % this.simulator.params.spawnProjectRate == 0) {
            this.spawnNextProject();
        }
    }

    spawnNextProject() {
        const possibleProjectNames = this.simulator.params.projectNames;
        this.lastSpawnedIndex = (this.lastSpawnedIndex + 1) % possibleProjectNames.length;

        var newProjectName = possibleProjectNames[this.lastSpawnedIndex];
        var newProject = this.getNewProject(newProjectName, this.simulator.hoursPassed);

        this.projects.push(newProject);
    }

    //Get all tasks which are ready to be worked on
    getAllReadyTasks() {
        var returnTasks = []

        this.projects.forEach(currProject => {
            returnTasks = returnTasks.concat(currProject.getReadyToStartTasks())
        })

        return returnTasks;
    }

}

module.exports = { ProjectPool };
